export default __webpack_public_path__ + "static/media/jackpots.7f9864a8.png";